export const AUTH_SESSION_STALE_TIME = 30_000
